/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.1
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
	HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable, of }                               from 'rxjs';
import { tap }                                          from 'rxjs/operators';

import { MetadataDefinition } from '../model/metadataDefinition';
import { MetadataDefinitionEnum } from '../model/metadataDefinitionEnum';
import { CacheService } from './cache.service';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class MetadataDefinitionService {

	protected basePath = environment.demoApi;
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, private cacheService: CacheService, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
     * Return the MetadataDefinition object
     * Retreive the catalog values for some fields
     * @param metadataDefinitionId The catalog id of metadata definitions defined inside Encores system
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public metadatadefinitionGet(metadataDefinitionId: MetadataDefinitionEnum, observe?: 'body', reportProgress?: boolean): Observable<Array<MetadataDefinition>>;
	public metadatadefinitionGet(metadataDefinitionId: MetadataDefinitionEnum, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MetadataDefinition>>>;
	public metadatadefinitionGet(metadataDefinitionId: MetadataDefinitionEnum, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MetadataDefinition>>>;
	public metadatadefinitionGet(metadataDefinitionId: MetadataDefinitionEnum, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    const cacheKey = metadataDefinitionId;
    const cachedData = this.cacheService.getCache(cacheKey);

    if (environment.enableCache && cachedData) {
      return of(JSON.parse(cachedData));
    }

		let headers = this.defaultHeaders;


		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<{ [key: string]: MetadataDefinition; }>('get',`${this.basePath}/metadatadefinition/${encodeURIComponent(String(metadataDefinitionId))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		).pipe(
        tap(response => {this.cacheService.setCache(cacheKey, JSON.stringify(response));
       })
    );
	}

}
